import { AxiosResponse } from "axios";
import axios from "./AxiosService";

export interface LabwareType {
  arrayMethodPlateRole: number;
  labwareTypeCode: string;
  labwareTypeId: number;
  minLabwareVolume: number;
  maxLabwareVolume: number;
}

export interface GetASAMAndPlateInfoData {
  acceptablePlateTypes: any[];
  arraySystemAutomationMethodId: number | null;
  system: number | null;
}

export interface NucleofectionWorklistService {
  getASAMAndPlateInfo(
    methodReservationId: string
  ): Promise<AxiosResponse<GetASAMAndPlateInfoData>>;
}
export default {
  async getASAMAndPlateInfo(methodReservationId: string) {
    const params = new URLSearchParams();
    params.append("methodReservationId", methodReservationId);

    return axios.get<GetASAMAndPlateInfoData>(
      "api/NucleofectionWorklist/GetASAMAndPlateInfo",
      { params }
    );
  },
} as NucleofectionWorklistService;
